/**
 * Duration of the SlidePanel CSS transition in milliseconds.
 * Must stay in sync with the `transition: transform 0.25s` value
 * in slide-panel.scss.
 *
 * Centralised here so SlidePanel.tsx and useSlidePanelMounted share
 * the exact same value without duplication.
 */
export const SLIDE_PANEL_TRANSITION_MS = 250;

/**
 * Extra grace period (ms) added on top of SLIDE_PANEL_TRANSITION_MS.
 *
 * Used in two places with slightly different roles:
 *  - SlidePanel.tsx: delays focus restoration so it fires after the internal
 *    unmount timer (TRANSITION_MS), ensuring the panel DOM is gone before the
 *    trigger element receives focus.
 *  - useSlidePanelMounted: added to the unmount timer itself, so external
 *    consumers remove the panel component only after the CSS transition
 *    has fully settled.
 *
 * Why 50ms? CSS transitions are specified in milliseconds but browsers schedule
 * them on paint frames, so the actual transition end can drift by one or two
 * frames (~16–33ms at 60fps). The buffer absorbs that slack in both callers.
 */
export const SLIDE_PANEL_UNMOUNT_BUFFER_MS = 50;

/** Delay before scrolling/focusing a field after validation error navigation. */
export const VALIDATION_ERROR_NAVIGATION_DELAY_MS = 50;

/** Default DOM attribute used to locate form fields for validation navigation. */
export const DEFAULT_FORM_FIELD_ATTRIBUTE = "data-form-field-name";
